import React from 'react';
import { useSelector } from "react-redux";
import {Link, useLocation} from "react-router-dom";
import { limitStr } from "utils/utils";
import styles from './RestaurantItem.module.css';
import phoneWhite from "assets/images/icon-phone-white.svg";
import placeholder360x225 from "assets/placeholder/360x225.png";
import { promotionTypes } from "config/promotionTypes";
import playClickSpecial from "utils/playClickSpecial";

function RestaurantFloorsItems(props){
    const langState = useSelector((state) => state.language.lang);
    const location = useLocation();
    const pathname = location.pathname.replace(/\/+$/, "");
    return(
        <div className={styles.restaurant_item}>
            <div className={styles.wrapp_title}>
                <h4 className={styles.title}>{limitStr(props.name)}</h4>
                <div className={styles.phone_number}>
                    <img src={phoneWhite} className={styles.phone_image} alt={props.name} />
                    {props.phone}
                </div>
                {
                    props.promotion_tag && props.promotion_tag != 0 && (
                        <img src={promotionTypes[langState][props.promotion_tag]} alt="promotion image" className={`${styles.promotion}  ${props.promotion_tag === 'new' ? styles.new : ''}`} />
                    )    
                }
            </div>
            <div className={styles.wrapp_image}>
                <Link to={{ pathname: `${pathname}/${props.id}`, search: `?code=${props.code}`}} onClick={playClickSpecial}>
                    <img src={props.thumb || placeholder360x225} alt={props.name}/>
                </Link>
            </div>
        </div>    
    );
}   
export default RestaurantFloorsItems;